import { SERVER_URLS } from './baseURL';
/**
 * Object to specify variables for DEV environment
 * @property {boolean} production Boolean to specify if the environment is production env
 * @property {string} apisServerUrl Main API server URL
 * @property {number} apisPort Port for the main API server (0 if using default HTTPS port)
 * @property {string} identityServerUrl Identity/Auth server URL
 * @property {number} identityPort Port for the identity server
 * @property {string} baseUrl App base URL (Cloudflare Pages URL)
 * @property {string} appBaseHref Base href for app routing
 * @property {string} identityBaseHref Base href for identity routing
 */
export const environment = {
  production: false,
  apisServerUrl: SERVER_URLS.apiDev,
  apisPort: SERVER_URLS.apiPortDev,
  identityServerUrl: SERVER_URLS.identityDev,
  identityPort: SERVER_URLS.identityPortDev,
  baseUrl: 'https://promsy-front-r14.pages.dev/',
  appBaseHref: '',
  identityBaseHref: '',
};
